import clsx from 'clsx';
import type { ComponentProps } from 'react';

const Skeleton = ({ className, 'aria-label': ariaLabel, ...props }: ComponentProps<'div'>) => {
  return (
    <div
      {...props}
      data-slot="skeleton"
      className={clsx('animate-pulse rounded-md bg-muted', className)}
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label={ariaLabel || 'Loading...'}
    />
  );
};

export { Skeleton };
